import { render, staticRenderFns } from "./request-pending.vue?vue&type=template&id=443784f4&scoped=true&"
import script from "./request-pending.vue?vue&type=script&lang=js&"
export * from "./request-pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443784f4",
  null
  
)

export default component.exports